
import AwardBadge from '~/static/award-badge.svg?inline';
import DealPropertyList from './DealPropertyList.vue';
import GuaranteeText from '../../pdp/GuaranteeText.vue';

export default {
  components: { AwardBadge, DealPropertyList, GuaranteeText },

  props: {
    deal: {
      type: Object,
      required: true,
    },
  },

  computed: {
    callout() {
      return this.deal.money_back_callout_type;
    },
  },
};
